export const TIME_FORMAT_WITH_UTC = "YYYY-MM-DDTHH:mm:ssZ";
export const DATE_FORMAT = "YYYY-MM-DD";
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
export const IS_DEMO = ENVIRONMENT === "demo";
